import { protectedApi } from '@api/index';
import { formatApiResponse } from '@utils/helpers';

export async function getTimezoneListApi() {
    const endpoint = `/timezone/list`;
    try {
      const response = await protectedApi.get(endpoint);
      return formatApiResponse(response);
    } catch (error) {
      return formatApiResponse(error);
    }
  }